import { user } from 'src/StateObserver';
import { AssetGroup } from '@play-co/timestep-core';
import { canMigrateFromGuestMode } from 'src/game/guest/guest.sequence';

/**
 * Check if user should experience the new FTUE loading, only if user never completed the 1st level.
 * Also only if user is will not migrate from guest, to avoid a conflicting experience.
 * If user can migrate from guest, just load things as usual, since it can skip the FTUE tutorials on the fly.
 */
export function isLoadingFTUEActive() {
  return user().match2.level === 1 && !canMigrateFromGuestMode();
}

/**
 * Get puzzle assets that can be loaded in background, while playing the first level
 */
export function getFirstPuzzleBackgroundAssets() {
  return new AssetGroup([
    'assets/sounds/sfx/puzzle-basic-destroy.mp3',
    'assets/sounds/sfx/puzzle-block-drop.mp3',
    'assets/sounds/sfx/puzzle-block-drop2.mp3',
    'assets/sounds/sfx/puzzle-hat-destroy-new.mp3',
    'assets/sounds/sfx/puzzle-power-block-form.mp3',
    'assets/sounds/sfx/puzzle-power-block-spawn.mp3',
    'assets/sounds/sfx/puzzle-invalid.mp3',
    'assets/sounds/sfx/puzzle-rocket-activate.mp3',
    'assets/sounds/sfx/puzzle-bomb-activate.mp3',
    'assets/sounds/sfx/puzzle-combo-rocket-rocket.mp3',
    'assets/sounds/sfx/puzzle-combo-rocket-bomb.mp3',
    'assets/sounds/sfx/puzzle-combo-bomb-bomb.mp3',
    'assets/sounds/sfx/puzzle-combo-cube-cube.mp3',
    'assets/sounds/sfx/puzzle-combo-cube-replace.mp3',
    'assets/sounds/sfx/puzzle-cube-activate.mp3',
    'assets/sounds/sfx/puzzle-cube-spin.mp3',
    'assets/sounds/sfx/sfx-star1.mp3',
    'assets/sounds/sfx/sfx-star2.mp3',
    'assets/sounds/sfx/sfx-star3.mp3',
  ]);
}
